import axios from '../utils/axios'

export async function order (userdata) {
  let { data } = await axios({
    url: '/v1/order',
    method: 'post',
    data: userdata
  })
  return data
}
